<template>
  <el-container class="content">
    <el-menu
      class="el-menu-vertical"
      :default-active="currentRouter"
      background-color="#7985B5"
      text-color="#FFFFFF"
      active-text-color="#7985B5"
      :collapse="isCollapse"
      @select="selectMenu"
      router
    >
      <div style="background-color:#6A759F" class="el-menu-item">
        <span class="title">预约抢号管理后台</span>
      </div>
      <el-menu-item index="/eduHome/projectList">
        <a class="logo logo1" ></a>
        <span slot="title">体检预约管理</span>
      </el-menu-item>
      <div class="menu-divider"></div>
      <el-menu-item index="/eduHome/confirmList">
        <a class="logo logo2" ></a>
        <span slot="title">现场确认预约管理</span>
      </el-menu-item>
      <div class="menu-divider"></div>
    </el-menu>
    <el-main style="background-color:#F6F5F5;">
      <span id="fold" @click="changeCollapse" class="collapse-btn">
        <img src="@/assets/img/fold.png" />
      </span>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </el-main>
  </el-container>
</template>
<script>
import "@/assets/css/eduMain.css";
export default {
  data() {
    return {
      isCollapse: false,
      currentRouter:'',
    };
  },
  mounted() {
    this.currentRouter = this.$route.fullPath
  },
  methods: {
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
      let deg = this.isCollapse ? 180 : 0;
      document.getElementById("fold").style.transform =
        "rotate(" + deg + "deg)";
    },
    selectMenu() {
      if (this.isCollapse) {
        this.changeCollapse();
      }
    }
  }
};
</script>
<style scoped>
.el-menu-vertical:not(.el-menu--collapse) {
  width: 220px;
}

.icon {
  color: #ffffff;
}

.title {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
}

.menu-divider {
  margin: 0;
  background-color: rgb(102, 112, 152);
  height: 1px;
}

.el-menu-item.is-active {
  background-color: #ffffff !important;
}

.el-menu-item i {
  color: #fff !important;
}

.el-menu-item.is-active i {
  color: #7985b5 !important;
}
</style>